module.exports = __webpack_public_path__ + "img/chevron-down.840257d1.svg";